import { render, staticRenderFns } from "./qaItem.vue?vue&type=template&id=545eee13&scoped=true&"
import script from "./qaItem.vue?vue&type=script&lang=js&"
export * from "./qaItem.vue?vue&type=script&lang=js&"
import style0 from "./qaItem.vue?vue&type=style&index=0&id=545eee13&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545eee13",
  null
  
)

export default component.exports